"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usableAccount = usableAccount;

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

var _util2 = require("@polkadot/util");

var _types = require("./types");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
function systemAccount(api, tokenType, accountId) {
  if (tokenType !== _types.TokenType.Ring && tokenType !== _types.TokenType.Kton) {
    return (0, _rxjs.of)({
      usableBalance: api.registry.createType('Balance', 0)
    });
  }

  return api.queryMulti([[api.query.system.account, accountId], [api.query.balances.locks, accountId], [api.query.kton.locks, accountId]]).pipe((0, _rxjs.map)(_ref => {
    let [balanceInfo, locks, ktonLocks] = _ref;
    const {
      free,
      freeKton
    } = balanceInfo.data;
    let maxlock = new _util2.BN(0);
    let balanceFree = api.registry.createType('Balance');

    if (tokenType === _types.TokenType.Ring) {
      balanceFree = free;
      locks.forEach(item => {
        if (item.reasons.isFee) {
          return;
        }

        maxlock = (0, _util2.bnMax)(item.amount, maxlock);
      });
    } else {
      balanceFree = freeKton;
      ktonLocks.forEach(item => {
        if (item.reasons.isFee) {
          return;
        }

        maxlock = (0, _util2.bnMax)(item.amount, maxlock);
      });
    }

    return {
      usableBalance: api.registry.createType('Balance', balanceFree.sub(maxlock))
    };
  }));
}
/**
 * @name usableAccount
 * @description reserve balance for ring or kton coin
 * @example
 * <BR>
 *
 * ```javascript
 * const tokenType = 0;  0 present ring and 1 present kton
 * const ALICE = 'F7Hs';
 *
 * api.derive.balances.usableAccount(tokenType, ALICE ({ usableBalance }) => {
 *   console.log(`The usableBalance  ${usableBalance}.`);
 * });
 */


function usableAccount(instanceId, api) {
  return (0, _util.memo)(instanceId, (tokenType, accountId) => systemAccount(api, tokenType, accountId));
}